var _path, _line, _line2, _line3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 24L21.6464 24.3536C21.7894 24.4966 22.0045 24.5393 22.1913 24.4619C22.3782 24.3846 22.5 24.2022 22.5 24H22ZM10 24H9.5C9.5 24.2022 9.62182 24.3846 9.80866 24.4619C9.9955 24.5393 10.2106 24.4966 10.3536 24.3536L10 24ZM16 22L16.3536 21.6464C16.1583 21.4512 15.8417 21.4512 15.6464 21.6464L16 22ZM20 22L20.3536 21.6464C20.1583 21.4512 19.8417 21.4512 19.6464 21.6464L20 22ZM12 22L12.3536 21.6464C12.1583 21.4512 11.8417 21.4512 11.6464 21.6464L12 22ZM18 24L17.6464 24.3536C17.8417 24.5488 18.1583 24.5488 18.3536 24.3536L18 24ZM14 24L13.6464 24.3536C13.8417 24.5488 14.1583 24.5488 14.3536 24.3536L14 24ZM11 8.5H21V7.5H11V8.5ZM21.5 9V24H22.5V9H21.5ZM10.5 24V9H9.5V24H10.5ZM22.3536 23.6464L20.3536 21.6464L19.6464 22.3536L21.6464 24.3536L22.3536 23.6464ZM11.6464 21.6464L9.64645 23.6464L10.3536 24.3536L12.3536 22.3536L11.6464 21.6464ZM19.6464 21.6464L17.6464 23.6464L18.3536 24.3536L20.3536 22.3536L19.6464 21.6464ZM18.3536 23.6464L16.3536 21.6464L15.6464 22.3536L17.6464 24.3536L18.3536 23.6464ZM15.6464 21.6464L13.6464 23.6464L14.3536 24.3536L16.3536 22.3536L15.6464 21.6464ZM14.3536 23.6464L12.3536 21.6464L11.6464 22.3536L13.6464 24.3536L14.3536 23.6464ZM21 8.5C21.2761 8.5 21.5 8.72386 21.5 9H22.5C22.5 8.17157 21.8284 7.5 21 7.5V8.5ZM11 7.5C10.1716 7.5 9.5 8.17157 9.5 9H10.5C10.5 8.72386 10.7239 8.5 11 8.5V7.5Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 11.5,
    x2: 18.5,
    y2: 11.5,
    stroke: "black",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 14.5,
    x2: 18.5,
    y2: 14.5,
    stroke: "black",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 17.5,
    x2: 18.5,
    y2: 17.5,
    stroke: "black",
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/order.bee348da.svg";
export { ForwardRef as ReactComponent };